export const SensitiveApprovalPhase = {
  RequireConfirm: 'REQUIRE_CONFIRM',
  Pending: 'PENDING',
  StatusChanged: 'STATUS_CHANGED',
} as const

export const SensitiveApprovalStatus = {
  Pending: 'PENDING',
  Approved: 'APPROVED',
  Executing: 'EXECUTING',
  Executed: 'EXECUTED',
  Rejected: 'REJECTED',
  Canceled: 'CANCELED',
  Voided: 'VOIDED',
  Expired: 'EXPIRED',
  ExecuteFailed: 'EXECUTE_FAILED',
} as const

export type SensitiveApprovalPhaseValue = typeof SensitiveApprovalPhase[keyof typeof SensitiveApprovalPhase]
export type SensitiveApprovalStatusValue = typeof SensitiveApprovalStatus[keyof typeof SensitiveApprovalStatus]

export interface SensitiveApprovalResponse {
  needApproval?: boolean
  phase?: string
  requestId?: string
  ticketId?: number
  status?: string
  operationTypes?: number[]
  operationNames?: string[]
  businessType?: string
  businessId?: string
  businessName?: string
  existingTicket?: boolean
  canAudit?: boolean
  message?: string
  approvalDetailRows?: SensitiveApprovalDetailRow[]
  defaultApplicationReason?: string
  defaultApplicationReasonEnabled?: boolean
}

export interface SensitiveApprovalDetailRow {
  label: string
  value: number | string
}

export interface SensitiveApprovalWebsocketPayload {
  phase?: string
  ticketId?: number
  requestId?: string
  status?: string
  operationNames?: string[]
  businessType?: string
  businessId?: string
  businessName?: string
  applicantCorpUserId?: number | string
  applicantMerchantUserId?: number | string
  applicantName?: string
  message?: string
}

export interface SensitiveApprovalNotification {
  title: string
  message: string
  type: 'success' | 'warning' | 'info' | 'error'
}
